import { ENROLL_STATES } from '../constants';

export const MIN_WIDTH_MID_SCREEN = 1024;

/**
 * Returns true when the viewport is below the desktop threshold (1024px).
 * Mirrors the same breakpoint used by axp-benefits-view-all.
 */
export const isMobileBreakpoint = () => window.innerWidth < MIN_WIDTH_MID_SCREEN;

/**
 * Extracts the LEARNMORE link from a raw benefit object by walking the
 * layout states in priority order.
 */
export const getLearnMoreLink = (benefit) => {
  const linkKey = ENROLL_STATES.find(
    (state) => benefit?.summary?.layout?.[state]?.callToAction?.LEARNMORE?.link
  );
  return benefit?.summary?.layout?.[linkKey]?.callToAction?.LEARNMORE?.link || null;
};

/**
 * Normalises a benefit link so that:
 *  - absolute external URLs (http/https) are returned as-is
 *  - relative slugs are prefixed with /card-benefits/
 */
export const normalizeBenefitLink = (link) => {
  if (!link) return null;
  if (link.startsWith('http')) return link;
  const slug = link.startsWith('/') ? link.slice(1) : link;
  return `/card-benefits/${slug}`;
};

/**
 * High-level guard: if on mobile, navigate to the benefit detail route
 * instead of opening quick-view. Returns `true` when navigation occurred
 * (i.e. quick-view should NOT open), `false` otherwise (desktop path).
 */
export const navigateIfMobile = (benefit) => {
  if (!isMobileBreakpoint()) return false;

  const raw = getLearnMoreLink(benefit);
  const destination = normalizeBenefitLink(raw);

  if (destination) {
    window.location.assign(`${destination}?from=activity`);
    return true;
  }
  return false;
};
